"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignUpPage = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const PasswordInputControl_1 = require("../../../controls/PasswordInputControl");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("../../../constants/routes");
const user_1 = require("../../../reducers/slices/user/user");
const sign_up_thunk_1 = require("../../../reducers/slices/user/thunks/sign_up_thunk");
const facetecBypass_1 = require("../../../helpers/facetecBypass");
const SignUpPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { entryTheme } = (0, react_redux_1.useSelector)((state) => state.entryState);
    const { user, token, isLoading, newRegistration, faceTecAuthorized } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [messages, setMessages] = (0, react_1.useState)({
        email: "",
        name: "",
        surname: "",
        password: "",
        confirm_password: "",
    });
    const setMessagesFun = (name, message) => {
        setMessages(Object.assign(Object.assign({}, messages), { [name]: message }));
    };
    (0, react_1.useEffect)(() => {
        if ((user === null || user === void 0 ? void 0 : user._id) && token) {
            // BYPASS CHECK: Staff with bypass permission or mobile users skip FaceTec
            if ((0, facetecBypass_1.shouldBypassFaceTec)()) {
                console.log("🔓 SignUp - Bypass active, navigating directly to console");
                navigate(routes_1.CONSOLE_ROUTE);
                return;
            }
            // For new registrations, redirect to FaceTec enrollment
            if (newRegistration && !(user === null || user === void 0 ? void 0 : user.facetecDBRef)) {
                navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.FACETEC_ROUTE}?enroll=true&return_to=console`);
            }
            else if (!(user === null || user === void 0 ? void 0 : user.facetecDBRef)) {
                // Existing user without FaceTec - require enrollment
                navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.FACETEC_ROUTE}?enroll=true&return_to=console`);
            }
            else if (!faceTecAuthorized) {
                // User has FaceTec but not authenticated this session - require authentication
                navigate(`${routes_1.CONSOLE_ROUTE}${routes_1.FACETEC_ROUTE}?return_to=console`);
            }
            else {
                navigate(routes_1.CONSOLE_ROUTE);
            }
        }
    }, [user, token, newRegistration, faceTecAuthorized]);
    const onControlChanged = (name, value) => {
        dispatch((0, user_1.setUser)(Object.assign(Object.assign({}, user), { [name]: value })));
    };
    const validate = () => {
        let messageCount = 0;
        /*
    
              email: "",
        name: "",
        surname: "",
        password: "",
        confirm_password: "",
        */
        if (!user.name) {
            messageCount++;
            setMessagesFun("name", "First name is required.");
        }
        if (!user.surname) {
            messageCount++;
            setMessagesFun("surname", "Last Name is required.");
        }
        if (!user.email) {
            messageCount++;
            setMessagesFun("email", "Email is required.");
        }
        if (!user.password) {
            messageCount++;
            setMessagesFun("password", "Password is required.");
        }
        if (user.password !== user.confirm_password) {
            messageCount++;
            setMessagesFun("confirm_password", "Confirm password does not match your password.");
        }
        return messageCount ? false : true;
    };
    return (react_1.default.createElement("div", { className: "flex flex-col gap-y-4 h-full justify-center w-full lg:w-[700px] py-4 lg:py-0 px-4 lg:px-8" },
        react_1.default.createElement("div", { className: "text-3xl font-bold" }, "Sign Up"),
        react_1.default.createElement("div", { className: "w-10" },
            react_1.default.createElement(doshx_controls_web_1.DividerControl, { orientation: "horizontal", lineColor: "bg-black", addPadding: false })),
        react_1.default.createElement("div", { className: "text-sm font-light" }, "Sign up using your email address"),
        react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4" },
            react_1.default.createElement("div", { className: "grid lg:flex gap-4 w-full" },
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "First Name", type: "text", value: user.name, errorText: messages.name, borderColor: "border-borders", onChange: (v) => {
                            onControlChanged("name", v);
                        } })),
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Last Name", type: "text", value: user.surname, errorText: messages.surname, borderColor: "border-borders", onChange: (v) => {
                            onControlChanged("surname", v);
                        } }))),
            react_1.default.createElement("div", { className: "grid lg:flex gap-4 w-full" },
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement(doshx_controls_web_1.TextInputControl, { label: "Email", type: "text", value: user.email, errorText: messages.email, borderColor: "border-borders", onChange: (v) => {
                            onControlChanged("email", v);
                        } })),
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement(PasswordInputControl_1.PasswordInputControl, { label: "Password", borderColor: "border-borders", value: user.password, errorText: messages.password, onChange: (v) => {
                            onControlChanged("password", v);
                        } }))),
            react_1.default.createElement("div", { className: "grid lg:flex gap-4 w-full" },
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement(PasswordInputControl_1.PasswordInputControl, { label: "Confirm Password", borderColor: "border-borders", value: user.confirm_password, errorText: messages.confirm_password, onChange: (v) => {
                            onControlChanged("confirm_password", v);
                        } }))),
            react_1.default.createElement("div", { className: "w-[200px]" },
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Sign Up", loading: isLoading, backgroundColor: "bg-secondary", onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                        if (validate()) {
                            dispatch((0, sign_up_thunk_1.sign_up_thunk)());
                        }
                    }) }))),
        react_1.default.createElement("div", { className: "flex gap-1 pt-4 items-center justify-center" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Already have an account?", textColor: "text-black" }),
            react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { label: "Sign In", textColor: entryTheme.config.colors.link.text, onClick: () => {
                    navigate(`${routes_1.WELCOME_ROUTE}${routes_1.LOG_IN_ROUTE}`);
                } }))));
};
exports.SignUpPage = SignUpPage;
